import { getTenant, getUserName } from '../helpers';
import { api } from './api';

export function populateCredentialViewData(credentialID, callback) {

  const filterCredential = (data) => {
    let filteredResult = null;

// Check if data and data.body are defined and that data.body is an array with at least one element
    if (data && Array.isArray(data.body) && data.body.length > 0) {
      // Use find on the first element's data array only if it exists and is an array
      const items = data.body[0].data;
      if (Array.isArray(items)) {
        filteredResult = items.find(result =>
          result?.credentialDetails?.entityId === credentialID,
        );
      }
    }
    callback(filteredResult);

  };
  api.iblaxdApiCallWrapper(
    (args) => api.iblaxdcredapi.credentialsOrgsUsersAssertionsRetrieve(...args),
    getTenant(),
    getUserName(),
    getUserName(),
  )((err, data, response) => callback(filterCredential(response)));


}
